import React from 'react';
import PropTypes from 'prop-types';

const ContentEntityLayout = ({eventsPanel, pillBar, spotifyArtistId}) => {
  return (
    <div className="EntityPage__content" data-spotify-artist-id={spotifyArtistId}>
      <section className="EntityPage__main">
        {pillBar}
        {

          /**
           * Events Panel Section
           *
           */
          eventsPanel
        }
      </section>
    </div>
  );
};

ContentEntityLayout.propTypes = {
  /**
   * Events Panel Section
   */
  eventsPanel: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,

  /**
   * Pill Bar Section
   */
  pillBar: PropTypes.object,

  /**
   * Spotify Artist ID
   */
  spotifyArtistId: PropTypes.string,
};

export default ContentEntityLayout;
